var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from 'moment-timezone';
export var convertToCommissionPlan = function (commissionPlanDto, masterData, timeZone) { return ({
    id: commissionPlanDto.id,
    uuid: commissionPlanDto.uuid,
    from: moment(commissionPlanDto.start_at).tz(timeZone),
    to: commissionPlanDto.end_at === null ? null : moment(commissionPlanDto.end_at).tz(timeZone),
    staffId: commissionPlanDto.staff_id,
    commissions: commissionPlanDto.commissions.map(function (commissionDto) { return convertToCommission(commissionDto, masterData); }),
    active: commissionPlanDto.active,
    createdAt: moment(commissionPlanDto.created_at).tz(timeZone),
    updatedAt: moment(commissionPlanDto.updated_at).tz(timeZone),
}); };
export var convertToCommission = function (commissionDto, masterData) { return ({
    id: commissionDto.id,
    uuid: commissionDto.uuid,
    minimum: commissionDto.maximum,
    maximum: commissionDto.minimum,
    rate: commissionDto.rate,
    category: masterData.commissions.categories.find(function (category) { return category.id === commissionDto.category_id; }),
    cadence: __assign({}, masterData.commissions.cadences.find(function (cadence) { return cadence.id === commissionDto.category_id; })),
}); };
export var sortCommissionPlans = function (commissionPlans) {
    return commissionPlans.sort(function (commissionPlan, otherCommisionPlan) {
        return commissionPlan.from.diff(otherCommisionPlan.from, 'milliseconds') * -1;
    });
};
export var convertToReport = function (reportDto, timeZone) {
    var _a;
    return ({
        bookingCount: reportDto.booking_count,
        totalCommissions: reportDto.total_commissions,
        sales: ((_a = reportDto.sales) !== null && _a !== void 0 ? _a : []).map(function (saleReportDto) { return convertToSaleReport(saleReportDto, timeZone); }),
    });
};
var convertToSaleReport = function (saleReportDto, timeZone) { return ({
    id: saleReportDto.id,
    uuid: saleReportDto.uuid,
    invoiceLineId: saleReportDto.invoice_line_id,
    commissionId: saleReportDto.commission_id,
    amount: saleReportDto.amount,
    customerName: saleReportDto.customer_name,
    commissionAmount: saleReportDto.commission_amount,
    saleDate: moment(saleReportDto.sale_date).tz(timeZone),
    createdAt: moment(saleReportDto.created_at).tz(timeZone),
    updatedAt: moment(saleReportDto.updated_at).tz(timeZone),
    bookingDate: moment(saleReportDto.booking_date).tz(timeZone),
    invoice: {
        id: saleReportDto.invoice_number.id,
        number: saleReportDto.invoice_number.number,
    },
    staff: {
        id: saleReportDto.staff.id,
        firstName: saleReportDto.staff.first_name,
        lastName: saleReportDto.staff.last_name,
    },
    description: saleReportDto.description,
    commissionRate: saleReportDto.commission_rate,
}); };
